import axios  from "axios";
export const GetSurveyors = async() => {
    try {
        const response = await axios.get('https://land-survey-project-2.onrender.com/GetSurveyors');
        if(response && response.data){
            if(response.data.surveyors){
                return response.data.surveyors;
            }
        }
        return [];
    } catch (err) {
    console.log(err);
    if(err){
        console.log(err);
    }
     return [];
    }
}